import styled from "styled-components";
import media from "utils/media";
import { Times } from "styled-icons/fa-solid";

export const Overlay = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 100vw;
  background: rgb(83, 86, 90, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 13;
`;

export const Modal = styled.div`
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 3px 6px 0px rgba(0, 0, 0, 0.16);
  height: auto;
  position: relative;
  max-height: 88vh;
  overflow-y: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding: 20px 60px 40px 60px;
  min-width: 650px;
`;

export const ImageContainer = styled.div`
  width: 100%;
  min-height: 100%;
  height: auto;
  background-image: url(${({ imgUrl }) => imgUrl});
  background-size: cover;
  background-repeat: no-repeat;
  flex: 1;
`;

export const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TextTitle = styled.h1`
  font-family: MontserratBold;
  font-size: 20px;
  font-weight: bold;
  color: ${(props) => props.theme.default.pageTitle.color};
`;

export const TextDescription = styled.p`
  font-family: "MontserratLight";
  font-size: 18px;
  font-weight: 400;
  color: ${(props) => props.theme.default.pageTitle.color};
  margin-top: 18px;
  margin-bottom: 30px;
  & > span {
    font-weight: 600;
    /* font-size: 16px; */
  }
`;

export const CloseButton = styled.button`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 6px;
  background: none !important;
  outline: none !important;
  border: none !important;
  z-index: 19;
  &:hover {
    cursor: pointer;
  }
`;

export const CloseIcon = styled(Times)`
  color: ${(props) => props.theme.default.pageTitle.color};
  size: 26px;
  font-weight: 200;
`;
